'use client';

import { useEffect, useState } from 'react';

// Renders the current year on the client so SSR/ISR-cached HTML doesn't show
// a stale year after the Jan 1 rollover. Falls back to a build-time year on
// first paint to avoid an obviously empty <span>.
export function FooterYear({ fallback }: { fallback: number }) {
  const [year, setYear] = useState(fallback);
  useEffect(() => {
    const current = new Date().getFullYear();
    if (current !== fallback) setYear(current);
  }, [fallback]);
  return <>{year}</>;
}
